// extracted by mini-css-extract-plugin
export default {"select-input":"select_select-input__nrGN5","field-label":"select_field-label__zPWwA"};